export const COLUMN_REPROCESS = {
  NO: 'No.',
  BUSINESS_DATA: 'Business Data',
  PLANT: 'Plant',
  FILE_NAME: ' File Name',
  PROCESS_DATE: ' Process Date',
};
